import { clx } from "@modules/common/components/ui"

type AmzPriceProps = {
  amount: number
  currencyCode: string
  size?: "sm" | "md" | "lg"
  className?: string
}

// Renders a price the Amazon way: small currency symbol, large integer part and
// superscript cents.
const AmzPrice = ({ amount, currencyCode, size = "md", className }: AmzPriceProps) => {
  const parts = new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: currencyCode.toUpperCase(),
  }).formatToParts(amount)

  const integer = parts
    .filter((p) => p.type === "integer" || p.type === "group")
    .map((p) => p.value)
    .join("")
  const fraction = parts.find((p) => p.type === "fraction")?.value ?? "00"
  const symbol = parts.find((p) => p.type === "currency")?.value ?? ""

  const big = { sm: "text-xl", md: "text-[28px]", lg: "text-[28px] small:text-[32px]" }[size]

  return (
    <span className={clx("inline-flex items-start leading-none text-[#0f1111]", className)}>
      <span className={clx(big, "font-medium")}>{integer}</span>
      <span className="text-xs mt-[3px] ml-[1px]">{fraction}</span>
      <span className="text-xs mt-[3px] ml-[2px]">{symbol}</span>
    </span>
  )
}

export default AmzPrice
